import { jsx, jsxs } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { breakpoints } from '../../../../utils/breakpoints.js';
import { getTestLabels } from '../../../../utils/getTestLabels.js';
import style from '../../DropdownMenu/DropdownMenu.module.scss.js';

const { componentTestLabel, elementTestLabel } = getTestLabels('DropdownMenuBody');
// TODO: re-focus trigger button when dropdown is closed
/**
 * [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Dropdowns/DropdownMenu/DropdownMenu.tsx)
 *
 * @param {string} breakpoint - **EXPERIMENTAL** (optional) Defaults to `lg`. Can be one of `xs`, `sm`, `md`, `lg` or `all`. Controls at which breakpoint (and up) the dropdown will be presented in a "desktop" fashion.
 * @param {ReactNode} dropdownButton - (optional) A button to insert at the bottom of the dropdown. Recommended: use a `PrimaryButton` with `length="full"`.
 * @param {boolean} isOpen - Set to `true` when dropdown should be open.
 */
const DropdownMenuBody = forwardRef((props, ref) => {
    const { breakpoint = 'lg', children, className, dropdownButton, isOpen, ...otherProps } = props;
    return (jsx("div", { ref: ref, "data-zta": componentTestLabel, className: classNames(className, style['z-dropdown-menu__body']), ...otherProps, children: jsxs("div", { children: [isOpen && breakpoint !== 'all' && (jsx("style", { children: `
                @media (max-width: ${breakpoints[breakpoint] - 1}px) {
                  body { overflow: hidden; }
                }
              ` })), children, dropdownButton && (jsx("div", { "data-zta": elementTestLabel('Footer'), className: style['z-dropdown-menu__footer'], children: dropdownButton }))] }) }));
});
DropdownMenuBody.displayName = 'DropdownMenuBody';

export { DropdownMenuBody };
//# sourceMappingURL=DropdownMenuBody.js.map
